export { Device } from '@cdc-internal/fe-toolbox/utils/device'

export enum ResponsiveBreakpoints {
  // Mobile view
  Small = 'small',
  Medium = 'medium',
  MidScale = 'midScale',
  Large = 'large',
  // Full display view in desktop
  XLarge = 'xlarge',
}

export const RESPONSIVE_BREAKPOINTS = ['small', 'medium', 'midScale', 'large', 'xlarge'] as const
